import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../common/ModalTrigger';
import RateInput from '../common/RateInput';
import SelectInputWithSymbol from '../common/SelectInputWithSymbol/SelectInputWithSymbol';
import { putRequest } from '../../requestUtils';
import dollarImage from '../../../assets/images/icons/dollar.svg';
import './EditInvoiceRate.scss';

class EditInvoiceRate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      netRate: props.net_rate,
      travelRate: props.travel_rate,
      grossRate: props.gross_rate,
      grossTravelRate: props.gross_travel_rate,
      hourLimit: props.hourLimit,
      takeRate: Math.round(props.takeRate * 100) / 100,
      updateProposalRate: true,
      quickbooksPaymentTerm: props.quickbooksPaymentTerm,
    };

    this.handleUpdateProposal = this.handleUpdateProposal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.updateTakeRate = this.updateTakeRate.bind(this);
  }

  handleUpdateProposal() {
    const { csrfToken, putUrl } = this.props;
    const {
      netRate,
      travelRate,
      grossRate,
      grossTravelRate,
      hourLimit,
      takeRate,
      updateProposalRate,
      quickbooksPaymentTerm,
    } = this.state;

    const rates = {
      net_rate: netRate * 100,
      travel_rate: travelRate * 100,
      gross_rate: grossRate * 100,
      gross_travel_rate: grossTravelRate * 100,
    };

    putRequest(
      putUrl,
      {
        rates,
        hour_limit: hourLimit,
        clora_take_rate: takeRate,
        update_proposal_rate: updateProposalRate,
        quickbooks_payment_term: quickbooksPaymentTerm,
      },
      csrfToken,
    ).then(() => window.location.reload());
  }

  calculatedTakeRate() {
    const { netRate, grossRate } = this.state;

    const rawRate = 1.0 - (netRate / grossRate);
    return Math.round(rawRate * 10000) / 100;
  }

  updateTakeRate() {
    if (isNaN(this.calculatedTakeRate()) || this.calculatedTakeRate() < 0) return;

    this.setState({ takeRate: this.calculatedTakeRate() });
  }

  handleChange(rate, key) {
    this.setState({ [key]: rate }, this.updateTakeRate);
  }

  render() {
    const { isEditingProposal, quickbooksPaymentTermOptions } = this.props;
    const {
      netRate,
      travelRate,
      grossRate,
      grossTravelRate,
      updateProposalRate,
      hourLimit,
      takeRate,
      quickbooksPaymentTerm,
    } = this.state;

    return (
      <ModalTrigger
        triggerText={isEditingProposal ? 'Edit Rates' : 'Edit Rates or Hour Limit'}
        submitButtonText="Yes, Update Rates"
        cancelButtonText="Cancel"
        handleSubmit={this.handleUpdateProposal}
        buttonStyles={isEditingProposal ? 'btn btn-default' : ''}
        triggerType={isEditingProposal ? 'button' : 'link'}
        idKey="edit-invoice-rate-modal"
        modalSize="md"
      >
        <div className="style-guide">
          <h1 className="mb-4">Do you want to edit the hourly rate, take rate, or hour limit?</h1>

          <div className="mb-2 body-text-2">
            <div className="mb-1 rate-label">Employer Hourly Rate (Gross):</div>
            <div className="input-container">
              <RateInput
                id="gross-rate"
                value={grossRate}
                containerClass="mt-3 me-2"
                onAnswerChange={(val) => this.handleChange(val, 'grossRate')}
              >
                <img className="pe-2" src={dollarImage} alt="dollar sign" />
              </RateInput>
              <div className="per-hour">/ hour</div>
            </div>
          </div>

          <div className="mb-2 body-text-2">
            <div className="mb-1 rate-label">Consultant Hourly Rate (Net)</div>
            <div className="input-container">
              <RateInput
                id="net-rate"
                value={netRate}
                onAnswerChange={(val) => this.handleChange(val, 'netRate')}
                placeholder="Net Hourly Rate"
              >
                <img className="pr-5" src={dollarImage} alt="dollar sign" />
              </RateInput>
              <div className="per-hour">/ hour</div>
            </div>
          </div>

          <div className="mb-2 body-text-2">
            <div className="mb-1 rate-label">Employer Travel Rate (Gross):</div>
            <div className="input-container">
              <RateInput
                id="gross-travel-rate"
                value={grossTravelRate}
                containerClass="mt-2 me-1"
                onAnswerChange={(val) => this.handleChange(val, 'grossTravelRate')}
              >
                <img className="pe-2" src={dollarImage} alt="dollar sign" />
              </RateInput>
              <div className="per-hour">/ hour</div>
            </div>
          </div>

          <div className="mb-2 body-text-2">
            <div className="mb-1 rate-label">Consultant Travel Rate (Net):</div>
            <div className="input-container">
              <RateInput
                id="travel-rate"
                value={travelRate}
                containerClass="mt-2 me-1"
                onAnswerChange={(val) => this.handleChange(val, 'travelRate')}
              >
                <img className="pe-2" src={dollarImage} alt="dollar sign" />
              </RateInput>
              <div className="per-hour">/ hour</div>
            </div>
          </div>
          <div className="mb-2 body-text-2">
            <div className="mb-1 rate-label">Hour Limit:</div>
            <div className="input-container">
              <RateInput
                id="hour-limit"
                value={hourLimit}
                onAnswerChange={(val) => this.handleChange(val, 'hourLimit')}
                containerClass="mt-2 me-1"
                placeholder="Max Hours"
              >
                <span className="input-group-addon">
                  <i className="fas fa-clock muted-gray-text pe-2" />
                </span>
              </RateInput>
              <div className="per-hour" />
            </div>
          </div>

          <div className="mb-2 body-text-2">
            <div className="mb-1 rate-label">Take Rate:</div>
            <div className="input-container">
              <RateInput
                id="take-rate"
                key={takeRate}
                value={takeRate}
                placeholder="Clora's Percentage"
                containerClass="mt-2 me-1"
                allowDecimals
                onAnswerChange={() => {}}
                readOnly
              >
                <span className="input-group-addon pe-2">%</span>
              </RateInput>
              <div className="per-hour" />
            </div>
          </div>
          <SelectInputWithSymbol
            label={(
              <div
                className="input-label"
                style={{
                  color: '#424242',
                  fontFamily: 'avenirnext-medium',
                }}
              >
                Quickbooks Payment Term
              </div>
            )}
            placeholder="Quickbooks Payment Term"
            inputName="quickbooksPaymentTerm"
            onChange={(e) => this.handleChange(e.value, 'quickbooksPaymentTerm')}
            errors=""
            containerWidth="80%"
            value={{ value: quickbooksPaymentTerm, label: quickbooksPaymentTerm }}
            options={quickbooksPaymentTermOptions}
          />
          {!isEditingProposal
            && (
            <div className="body-text-2">
              <label className="me-5" htmlFor="future">
                <input
                  type="radio"
                  id="future"
                  name="future"
                  checked={updateProposalRate === true}
                  onChange={() => this.handleChange(true, 'updateProposalRate')}
                />
                Update current and next timesheets
              </label>

              <label htmlFor="current">
                <input
                  type="radio"
                  id="current"
                  name="current"
                  checked={updateProposalRate === false}
                  onChange={() => this.handleChange(false, 'updateProposalRate')}
                />
                Update current timesheet
              </label>
            </div>
            )}
        </div>
      </ModalTrigger>
    );
  }
}

EditInvoiceRate.propTypes = {
  net_rate: PropTypes.number.isRequired,
  travel_rate: PropTypes.number.isRequired,
  gross_rate: PropTypes.number,
  gross_travel_rate: PropTypes.number,
  hourLimit: PropTypes.number,
  takeRate: PropTypes.number,
  csrfToken: PropTypes.string.isRequired,
  putUrl: PropTypes.string.isRequired,
  isEditingProposal: PropTypes.bool,
  quickbooksPaymentTerm: PropTypes.string.isRequired,
  quickbooksPaymentTermOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
};

EditInvoiceRate.defaultProps = {
  gross_rate: null,
  gross_travel_rate: null,
  hourLimit: null,
  takeRate: 20,
  isEditingProposal: false,
  quickbooksPaymentTermOptions: [],
};

export default EditInvoiceRate;
